import { render } from "./ClientesListTimeline.vue?vue&type=template&id=7643aeac&scoped=true"
import script from "./ClientesListTimeline.vue?vue&type=script&lang=js"
export * from "./ClientesListTimeline.vue?vue&type=script&lang=js"

import "./ClientesListTimeline.vue?vue&type=style&index=0&id=7643aeac&lang=scss&scoped=true"

import exportComponent from "/Users/rogeriolugaoveltem/Documents/mtex_nesher_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7643aeac"]])

export default __exports__